import { CACHE_RELEVANT_FORMS } from "../CacheHolder";
import { makeRequest } from "../baseApi";
import { langListShort } from "@/shared/utils/langs";
import { consoleLogGroup } from "../../utils/console";
import {parseResponseDefault} from "../not-sorted.utils";
import {normalizeFeaturedSearchSections} from "./utils";

export const relevantSearchSchemeRequest = (lang) => {
  let url = "/related/form/";
  let storageCacheName = CACHE_RELEVANT_FORMS;
  if (lang) {
    url += "?lang=" + langListShort;
    storageCacheName += "_" + lang;
  }

  return makeRequest({
    url: url,
    storageCacheName,
    parseResponse: parseResponseDefault,
  });
};

export const relevantSearchFacetAggregateRequest = (data) => {
  const { lang, query } = data;
  const queryLowerCase = query.toLowerCase();
  return makeRequest({
    url: `/related/aggregate/?lang=${lang}&query=${encodeURIComponent(queryLowerCase)}`,
    type: "get",
    memoryCache: true,
    memoryCacheName: "FC-" + lang + "-" + queryLowerCase,
    parseResponse: (response) => {
      // consoleLogGroup(`🪞 RS ${queryLowerCase} (${lang || "no lang"})`, response.data);
      return response.data;
    },
  });
};

export const fetchFeaturedSearchRequest = (query, langs = []) => {
  const cacheKey = query + (langs || []).toString();

  return makeRequest({
    url: `/search/featured/search?query=${encodeURIComponent(query)}&lang=${langs}`,
    type: "get",
    memoryCache: true,
    parseResponse: (response) => {
      if (response.data.sections) {
        return normalizeFeaturedSearchSections(response.data.sections);
      }

      return [];
    },
  });
};

export const fetchFeaturedForParagraph = (paraId /* e.g. "127.5" - id without a char prefix */) => {
  return makeRequest({
    url: `/search/featured/${paraId}`,
    type: "get",
    memoryCache: true,
    parseResponse: (response) => {
      if (response.data.sections) {
        return normalizeFeaturedSearchSections(response.data.sections);
      }

      return [];
    },
  });
};
